var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传图片",
            visible: _vm.uploadDialogVisible,
            width: "1000px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.uploadDialogVisible = $event
            },
            closed: _vm.handleDialogClose
          }
        },
        [
          !_vm.previewImage
            ? _c(
                "div",
                { staticStyle: { width: "950px", background: "#F0F1F4" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "custom-upload",
                      attrs: {
                        action: "",
                        "auto-upload": false,
                        multiple: false,
                        "show-file-list": false,
                        "on-change": _vm.handleFileChange,
                        "before-upload": _vm.beforeUpload,
                        drag: ""
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "upload-content" },
                        [
                          _c(
                            "el-button",
                            { attrs: { icon: "el-icon-upload2" } },
                            [_vm._v("点击上传")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "upload-tip-text" }, [
                            _vm._v("或将图片拖拽到此区域")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-desc" }, [
                            _vm._v(
                              "\n                        长、宽大于等于100px，小于等于4096px；图片大小不超过4M；"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                        支持上传jpg, png, jpeg, gif, bmp格式\n                    "
                            )
                          ])
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            : _c("div", { staticClass: "preview-container" }, [
                _c("div", { staticClass: "preview-box" }, [
                  _c("img", {
                    staticClass: "preview-img",
                    attrs: { src: _vm.previewImage, alt: "预览图片" }
                  })
                ])
              ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _vm.previewImage
                ? _c(
                    "el-button",
                    {
                      staticStyle: {
                        position: "absolute",
                        left: "16px",
                        bottom: "16px"
                      },
                      attrs: { type: "text", disabled: _vm.loading },
                      on: { click: _vm.resetUpload }
                    },
                    [_vm._v("重新上传")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.uploadDialogVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _vm.previewImage
                ? _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.loading, type: "primary" },
                      on: { click: _vm.handleStartUpload }
                    },
                    [_vm._v("\n              开始上传\n            ")]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3790d964", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3790d964","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/searchImgUploadDialog.vue
// module id = lnWy
// module chunks = 129